import { FaFacebook } from "react-icons/fa";
import { BiLogoInstagram } from "react-icons/bi";
import { GrLinkedinOption } from "react-icons/gr";
import { AiFillYoutube } from "react-icons/ai";
export const socialLinks = [
  {
    href: "https://www.facebook.com/idareorganisation/?_rdc=1&_rdr",
    icon: <FaFacebook />,
    data: "Safebed",
  },
  {
    href: "https://www.instagram.com/idareorganisation/",
    icon: <BiLogoInstagram />,
    data: "SafeBed",
  },
  {
    href: "https://www.linkedin.com/company/idareorg/",
    icon: <GrLinkedinOption />,
  },
  {
    href: "https://www.youtube.com/channel/UCSOKUsPA3zsd1u9qSid-7yQ?view_as=subscriber",
    icon: <AiFillYoutube />,
  },
];
